import { HexColor } from '@repo/shared/types';
import { groq } from 'next-sanity';
import { z } from 'zod';

import { link, SanityLink } from './link';

export const SanityAnnouncement = z.object({
  message: z.string(),
  background: HexColor,
  foreground: HexColor,
  link: SanityLink,
});
export type SanityAnnouncement = z.infer<typeof SanityAnnouncement>;

export const announcement = groq`{
  message,
  'background': background->color.hex,
  'foreground': foreground->color.hex,
  link[0] ${link},
}`;
